import api from './api';
import API_ROUTES from './apiRoutes';
import { currentSeasonYear } from '../utils/season';

const scoutProfileService = {
  getProfile: async () => {
    const response = await api.get(API_ROUTES.SCOUT.PROFILE);
    return response.data;
  },

  updateProfile: async (profileData) => {
    const response = await api.patch(API_ROUTES.SCOUT.PROFILE, profileData);
    return response.data;
  },

  // Profile Image APIs
  updateProfileImage: async (imageFile) => {
    const formData = new FormData();
    formData.append('profileImage', imageFile);
    const response = await api.patch(API_ROUTES.SCOUT.PROFILE_IMAGE, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  deleteProfileImage: async () => {
    const response = await api.delete(API_ROUTES.SCOUT.DELETE_PROFILE_IMAGE);
    return response.data;
  },

  // Dashboard APIs
  getDashboard: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const url = `${API_ROUTES.SCOUT.DASHBOARD}${queryString ? `?${queryString}` : ''}`;
    const response = await api.get(url);
    return response.data;
  },

  getSuggestions: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const url = `${API_ROUTES.SCOUT.SUGGESTIONS}${queryString ? `?${queryString}` : ''}`;
    const response = await api.get(url);
    return response.data;
  },

  // Follow/Unfollow APIs
  followPlayer: async (playerId) => {
    const response = await api.post(API_ROUTES.SCOUT.FOLLOW(playerId));
    return response.data;
  },

  unfollowPlayer: async (playerId) => {
    const response = await api.delete(API_ROUTES.SCOUT.UNFOLLOW(playerId));
    return response.data;
  },

  getFollowing: async (page = 1, limit = 10) => {
    const response = await api.get(API_ROUTES.SCOUT.FOLLOWING(page, limit));
    return response.data;
  },

  getFollowers: async (page = 1, limit = 10) => {
    const response = await api.get(API_ROUTES.SCOUT.FOLLOWERS(page, limit));
    return response.data;
  },

  // Follow/Unfollow Team APIs
  followTeam: async (teamId) => {
    const response = await api.post(API_ROUTES.SCOUT.FOLLOW_TEAM(teamId));
    return response.data;
  },

  unfollowTeam: async (teamId) => {
    const response = await api.delete(API_ROUTES.SCOUT.UNFOLLOW_TEAM(teamId));
    return response.data;
  },

  getFollowedTeams: async (page = 1, limit = 20) => {
    const response = await api.get(API_ROUTES.SCOUT.FOLLOWED_TEAMS(page, limit));
    return response.data;
  },

  // Get All Teams
  getScoutTeams: async (params = {}) => {
    const response = await api.get(API_ROUTES.SCOUT.TEAMS(params));
    return response.data;
  },

  // Team Roster API
  getTeamRoster: async (teamId, page = 1, limit = 50, seasonYear = currentSeasonYear(), filters = null, sortBy = null, sortOrder = null, statsType = null, category = null, scope = null) => {
    const response = await api.get(API_ROUTES.SCOUT.TEAM_ROSTER(teamId, page, limit, seasonYear, filters, sortBy, sortOrder, statsType, category, scope));
    return response.data;
  },

  // Uncommitted Tracker APIs
  getUncommittedPlayers: async (params = {}) => {
    const response = await api.get(API_ROUTES.SCOUT.UNCOMMITTED_PLAYERS(params));
    return response.data;
  },

  // Statistics APIs
  getTopPlayers: async (params = {}) => {
    const response = await api.get(API_ROUTES.SCOUT.TOP_PLAYERS(params));
    return response.data;
  },

  // Password Reset APIs
  forgotPassword: async (email) => {
    const response = await api.post(API_ROUTES.SCOUT.FORGOT_PASSWORD, { email });
    return response.data;
  },

  verifyOtp: async (email, otp) => {
    const response = await api.post(API_ROUTES.SCOUT.VERIFY_OTP, { email, otp });
    return response.data;
  },

  resetPassword: async (resetToken, newPassword, confirmPassword) => {
    const response = await api.put(API_ROUTES.SCOUT.RESET_PASSWORD, {
      resetToken,
      newPassword,
      confirmPassword,
    });
    return response.data;
  },

  // Filter APIs
  saveFilter: async (filterData) => {
    const response = await api.post(API_ROUTES.SCOUT.SAVE_FILTER, filterData);
    return response.data;
  },

  getFilters: async () => {
    const response = await api.get(API_ROUTES.SCOUT.GET_FILTERS);
    return response.data;
  },

  deleteFilter: async (filterId) => {
    const response = await api.delete(API_ROUTES.SCOUT.DELETE_FILTER(filterId));
    return response.data;
  },

  // Video Request API
  requestVideo: async (playerId, note) => {
    const response = await api.post(API_ROUTES.SCOUT.VIDEO_REQUEST, { playerId, note });
    return response.data;
  },

  getVideoRequestsByPlayer: async (playerId) => {
    const response = await api.get(API_ROUTES.SCOUT.GET_VIDEO_REQUESTS_BY_PLAYER(playerId));
    return response.data;
  },
};

export default scoutProfileService;
